
import React from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import LeftNav from "./leftnav";
import { useTheme } from '@mui/material/styles';

const TopNav = (props) => {
  const drawerWidth = props.drawerWidth;

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const theme=useTheme();
  /*
    Build an app bar across the top of the page
    Include 2 Drawers to contain the LeftNav - one persistent and one toggle-able for mobile
  */
  return (
    <>
      <AppBar
        position="fixed"
        color="primary"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          marginLeft: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open menu"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ marginRight: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{display: 'flex',width:'100%',
              alignItems: 'center',
              padding: theme.spacing(0, 1),
              ...theme.mixins.toolbar,// necessary for content to be below app bar
              justifyContent: 'center',}}>
                <Typography 
                  variant="h5" 
                  component="div"
                  sx={{
                    fontFamily: 'Lato, sans-serif',
                    fontWeight: 700,
                    color: '#107CF1',
                    letterSpacing: '0.5px',
                  }}
                >
                  optiontrader.tools
                </Typography>
            </Box>
        </Toolbar>
      </AppBar>

      <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }} aria-label="left nav">
        <Drawer variant="temporary" open={mobileOpen} onTransitionEnd={handleDrawerTransitionEnd} onClose={handleDrawerClose}
                ModalProps={{ keepMounted: true }}
                sx={{ display: { xs: 'block', sm: 'none' }, '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth }, }}>
          <LeftNav drawerWidth={drawerWidth} />
        </Drawer>

        <Drawer open variant="permanent"
                sx={{ display: { xs: 'none', sm: 'block' }, '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth }, }}>
          <LeftNav drawerWidth={drawerWidth} />
        </Drawer>
      </Box>
    </>
  );
}
export default TopNav;
